import { makeStyles } from "@material-ui/core";

export default makeStyles(({ spacing }) => ({
  paper: {
    width: 640,
    padding: spacing(3),
    display: "flex",
    flexDirection: "column",
    gap: spacing(3),
  },
  header: {
    borderBottom: "none",
    padding: 0,
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: spacing(2),
    padding: 0,
  },
  footer: {
    borderTop: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: spacing(1),
    padding: 0,
  },
}));
